// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87e5fc45","879":"d83b6ff6"}[chunkId] + ".chunk.js";
};